import { render, staticRenderFns } from "./reopenLead.vue?vue&type=template&id=33d17422"
import script from "./reopenLead.vue?vue&type=script&lang=js"
export * from "./reopenLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports